export default __webpack_public_path__ + "static/media/_ic_send.a76299be.svg";